import { render, staticRenderFns } from "./BusinessProfile.vue?vue&type=template&id=7d162d03&scoped=true&"
import script from "./BusinessProfile.vue?vue&type=script&lang=ts&"
export * from "./BusinessProfile.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessProfile.vue?vue&type=style&index=0&id=7d162d03&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d162d03",
  null
  
)

export default component.exports